import { Routes } from '@angular/router';
import { ContextResolver } from '@app/context.resolver';
import { ACCOUNT_ROUTES_PATHS_PARTIALS } from '@features/account/account-routes-paths';
import { AuthGuard } from '@features/login/auth-guard.service';
import { HasAccessToFbiGuard } from '@features/login/has-access-to-fbi-guard.service';
import { HasNoAccessToFbiGuard } from '@features/login/has-no-access-to-fbi-guard.service';
import { LastPageGuard } from '@features/login/last-page.guard';
import { LoginComponent } from '@features/login/login.component';
import { LoginGuard } from '@features/login/login.guard';
import { ProfileCompletionGuard } from '@features/login/profile-completion.guard';
import { VENUE_ROUTES_PATHS_PARTIALS } from '@features/venue/venue-routes-paths';
import { ContextBreadcrumbLabelResolver } from '@layout/global-header/context-breadcrumb-label.resolver';
import { LayoutComponent } from '@layout/layout.component';
import { CONSTANTS } from '@shared/constants';

export const AppRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        canActivate: [LastPageGuard],
        component: LoginComponent,
        pathMatch: 'full',
      },
      {
        path: CONSTANTS.ROUTES.LOGIN,
        canActivate: [LoginGuard],
        component: LoginComponent,
        pathMatch: 'full',
      },
      {
        path: CONSTANTS.ROUTES.NO_ACCESS,
        canActivate: [AuthGuard, HasNoAccessToFbiGuard],
        loadChildren: () =>
          import('@features/no-access/no-access.routes').then(m => m.NO_ACCESS_ROUTES),
      },
      {
        path: CONSTANTS.ROUTES.ADMIN,
        canActivate: [AuthGuard, ProfileCompletionGuard],
        component: LayoutComponent,
        loadChildren: () => import('@features/admin/admin.routes').then(m => m.AdminRoutes),
      },
      {
        path: ACCOUNT_ROUTES_PATHS_PARTIALS.BASE_PATH,
        canActivate: [AuthGuard, ProfileCompletionGuard],
        component: LayoutComponent,
        resolve: {
          resolveData: ContextResolver,
          breadcrumb: ContextBreadcrumbLabelResolver,
        },
        data: {
          breadcrumb: { translateKey: 'SHARED.SYSTEM.ACCOUNT' },
        },
        loadChildren: () => import('@features/account/account.routes').then(m => m.AccountRoutes),
      },
      {
        path: VENUE_ROUTES_PATHS_PARTIALS.BASE_PATH,
        canActivate: [AuthGuard, ProfileCompletionGuard],
        component: LayoutComponent,
        resolve: {
          resolveData: ContextResolver,
          breadcrumb: ContextBreadcrumbLabelResolver,
        },
        data: {
          breadcrumb: { translateKey: 'SHARED.SYSTEM.VENUE' },
        },
        loadChildren: () => import('@features/venue/venue.routes').then(m => m.VenueRoutes),
      },
      {
        path: CONSTANTS.ROUTES.PROFILE,
        canActivate: [AuthGuard, HasAccessToFbiGuard],
        component: LayoutComponent,
        loadChildren: () =>
          import('@features/user-profile/user-profile.routes').then(m => m.UserProfileRoutes),
      },
      {
        path: CONSTANTS.ROUTES.TOP_LEVEL_DASHBOARD,
        canActivate: [AuthGuard, HasAccessToFbiGuard, ProfileCompletionGuard],
        component: LayoutComponent,
        loadChildren: () =>
          import('@features/top-level-dashboard/top-level-dashboard.routes').then(
            m => m.topLevelDashboardRoutes
          ),
      },
      {
        // I have no better idea how to distinguish "outer" 404 (covering the whole app) from "inner" 404 (with sidebar)
        // so given that once upon a time there was a "home" component and routes starting with "/home"...
        path: `${CONSTANTS.ROUTES.HOME}/${CONSTANTS.ROUTES.NOT_FOUND}`,
        component: LayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import('@features/page-not-found/page-not-found.routes').then(
                m => m.PAGE_NOT_FOUND_ROUTES
              ),
          },
        ],
      },
      {
        path: `${CONSTANTS.ROUTES.NOT_FOUND}`,
        loadChildren: () =>
          import('@features/page-not-found/page-not-found.routes').then(
            m => m.PAGE_NOT_FOUND_ROUTES
          ),
      },
      {
        path: '**',
        redirectTo: `${CONSTANTS.ROUTES.NOT_FOUND}`,
      },
    ],
  },
];
